export default import.meta.ROLLUP_FILE_URL_c8NDPb65jC97v$fG97yG6g